import React from 'react'
import "./qualification.css"

export const Qualification  = () => {
  return (
    
    <section className="qualification section">
        <h2 className="section__title">Qualification</h2>
        <span className="section__subtitle">My personal journey</span>

        <div className="qualification__container container">
            <div className="qualification__tabs">
            <div className="qualification__button qualification__active button--flex">
             <i className="uil uil-graduation-cap qualification__icon"></i>{" "}Education
            </div>

            <div className="qualification__button button--flex">
                <i className="uil uil-briefcase-alt qualification__icon"  > </i> {" "}Experience<br/>/Internship
            </div>
            
            </div>
            

            <div className="qualification__sections">
                <div className="qualification__content">
<div className="qualification__data">

                 <div></div>

                    <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div>
                            <h3 className="qualification__title">Software Engineer</h3>
                            <span className="qualification__subtitle">RentMyStay.com  </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> June-2025-Persent
                            </div>
                        </div>

                    </div>
                
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title"> Bachelore-CSE</h3>
                            <span className="qualification__subtitle">IK Gujaral Punjab Technical university </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> (2022-2025)
                            </div>
                        </div>
                        
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>
                    
                    <div className="qualification__data">

                 <div></div>

                    <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div>
                            <h3 className="qualification__title">FullStack</h3>
                            <span className="qualification__subtitle">Besant Technologies  </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> Jul-2024-Nov-2024
                            </div>
                        </div>

                    </div>




                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">Diploma-CSE </h3>
                            <span className="qualification__subtitle">Govt Polytechnice College Darbhanga  </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> 2018-2021
                            </div>
                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                        
                    </div>

                    <div className="qualification__data">

                    <div></div>
                    <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                   
                        <div>
                            <h3 className="qualification__title">Java Internship </h3>
                            <span className="qualification__subtitle">Solitaire Infosys pvt ltd  </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> Jun 2023 - Aug 2023
                            </div>
                        </div>
                        
                        
                    </div>

                    <div className="qualification__data">

                        <div>
                            <h3 className="qualification__title">Matriculation </h3>
                            <span className="qualification__subtitle">Bihar School Examination Board Patna  </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> 2017
                            </div>
                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                        
                    </div>
                    

                    <div className="qualification__data">

                    <div></div>
                    <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div>
                            <h3 className="qualification__title">Frontend  </h3>
                            <span className="qualification__subtitle"> Aagaaz Training Centre Pvt Ltd </span>

                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i> Oct 2020-Dec 2020
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
                
            </div>
            
        </div>
    </section>
  )
}
